<template>
  <div class="basic-block block-about-fortune-base" :style="styles">
    <div class="content-wrap">
      <div class="block-about-fortune-base__inner">
        <img :src="`${path}aboutFortune_title.png`" class="block-about-fortune-base__title" alt="天宝占術で読み解くあなたの本質">
        <!-- <div class="block-about-fortune-base__title">外に見せる魅力<br>内に秘めた力が明らかに！</div>
        <div class="block-about-fortune-base__copy">天宝占術で占う<br>あなたの本質</div>
        <div class="block-about-fortune-base__text1">叶ここオリジナル占術「天宝占術」では、<br>生年月日から導き出される<br>魂のカタチ〈アピアランス〉と<br>心の中の輝き〈ジュエル〉から、<br>１人１人の天の宝を紐解き、<b>魅力・才能・弱点</b>などを見ていくことができます。</div> -->
        <swiper :options="swiperOption" ref="mySwiper" class="type-swiper">
          <swiper-slide v-for="(item, idx) of typeList" :key="idx">
            <div :class="['type-swiper__box', `type-swiper__box--${item.name}`]">
              <div class="type-swiper__name-wrap">
                <img :src="`/static/img/recommend/lp/kanoucoco/typeName_${item.name}.svg`" class="type-swiper__name">
                <div class="type-swiper__nameJa">{{ item.nameJa }}</div>
              </div>
              <ol class="type-swiper__list1"><li v-for="(list, i) in item.list1" :key="`list1${i}`">{{ list }}</li></ol>
              <ol class="type-swiper__list2"><li v-for="(list, i) in item.list2" :key="`list2${i}`">{{ list }}</li></ol>
              <img class="type-swiper__img" :src="`/static/img/recommend/lp/kanoucoco/type_${item.name}.png`" alt="" width="128">
            </div>
          </swiper-slide>
        </swiper>
        <div class="block-about-fortune-base__text2">天宝占術は、あなたの人生<br>を決して否定しません。<br>そのままの自分を愛する<br>方法を見つける占いです。</div>
        <lp-base-button
          label="無料占いをする"
          design="fill"
          :color-scheme="colorScheme"
          @clicked="clicked"
        />
        <img :src="`${path}aboutFortune_other.png`" class="block-about-fortune-base__other" alt="他にもこんなことが占えます">
      </div>
    </div>
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name: 'BlockAboutFortune2',
  components: {
    LpBaseButton,
    swiper,
    swiperSlide,
  },
  props: {
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    lpId: Number,
  },
  data() {
    return {
      path: '/static/img/recommend/lp/kanoucoco/',
      swiperOption: {
        speed: 600,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        loop: true,
      },
      typeList: [
        {
          name: 'Rose',
          nameJa: 'ローズ',
          list1: [
            '◆最後まで諦めずやり通す',
            '◆自分に向き合い、極める才能を持つ人',
          ],
          list2: [
            '・華やかで意志がある',
            '・完璧主義で弁が立つ',
            '・器用でセンスがある',
            '・反面、器用貧乏になりやすい',
            '・自分を柔軟に変えていくのが苦手',
          ],
        },
        {
          name: 'Linden',
          nameJa: '菩提樹',
          list1: [
            '◆好きなことを追求',
            '◆努力を継続していける才能を持つ人',
          ],
          list2: [
            '・コツコツと続けるのが得意',
            '・自分の意志を持って取り組む',
            '・他人の指示はうけたくない',
            '・人との相性がハッキリ分かれる',
            '・束縛が苦手な人が多い',
          ],
        },
        {
          name: 'Jasmine',
          nameJa: 'ジャスミン',
          list1: [
            '◆想像力が豊かで繊細',
            '◆人の気持ちに寄り添える才能の持つ人',
          ],
          list2: [
            '・繊細で空気を読む力がある',
            '・優しさや想像力を大事にしている',
            '・人が何を考えているか常に気を配る',
            '・人からの影響を受けやすい',
            '・優柔不断になることが多い',
          ],
        },
      ]
    }
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
  methods: {
    clicked () {
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}-free-shindan-button`,
      })
      location.href = this.$handoverParams(`/recommend/lp/${this.lpId}/basic/input`)
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-about-fortune-base {
  background: 
    url('/static/img/recommend/lp/kanoucoco/deco_flower.png') no-repeat top 24px right 20px/84px auto,
    url('/static/img/recommend/lp/kanoucoco/deco_wave.png') no-repeat 50% -56px/100% 112px;
  background-color: #FFECEB;
  padding: 115px 0 60px;
  font-family: "Hiragino Sans", sans-serif;
  &__inner {
  }
  &__title {
    display: block;
    width: 89.333%;
    max-width: 460px;
    margin: 0 auto 40px;
  }
  &__text2 {
    background: url('/static/img/recommend/lp/kanoucoco/counselor6.png') no-repeat 100% 100%/193px auto;
    padding: 0 142px 93px 36px;
    margin: 0 auto 60px;
    max-width: 420px;
    font-weight: 600;
    font-size: 16px;
    line-height: 2.38;
    color: $l_col_keycolor;
    > b {
      font-weight: 600;
      color: #FF9B96;
    }
  }
  &__other {
    display: block;
    width: 100%;
    max-width: 420px;
    margin: 60px auto 0;
  }
}
.type-swiper {
  padding: 26px 0 30px;
  margin: 0 0 60px;
  background: 
    url('/static/img/recommend/lp/kanoucoco/type_bg.png') repeat-x 50% 0/auto 46px,
    url('/static/img/recommend/lp/kanoucoco/type_bg.png') repeat-x 50% 100%/auto 46px;
  .swiper-slide {
    padding: 0 20px;
  }
  &__box {
    max-width: 400px;
    margin: 0 auto;
    padding: 19px 5px 75px 18px;
    background: #FFFFFF;
    border: 1px solid $l_col_keycolor;
    color: $l_col_keycolor;
    position: relative;
  }
  &__name-wrap {
    min-height: 48px;
    margin: 0 0 4px;
  }
  &__box--Jasmine &__name-wrap { margin-bottom: 0; }
  &__name {
    vertical-align: text-bottom;
  }
  &__box--Jasmine &__nameJa { margin-bottom: 11px; }
  &__nameJa {
    display: inline-block;
    font-weight: 600;
    font-size: unquote('min(3.733vw, 17px)');
    // line-height: 1;
    letter-spacing: 2px;
    vertical-align: bottom;
  }
  &__list1 {
    list-style: none;
    margin: 0 0 16px;
    padding: 0;
    font-weight: 600;
    font-size: unquote('min(4.266vw, 20px)');
    line-height: 1.625;
    > li::first-letter {
      font-size: unquote('min(3.2vw, 15px)');
      vertical-align: 0.13em;
    }
  }
  &__list2 {
    list-style: none;
    margin: 0;
    padding: 0;
    font-size: unquote('min(3.733vw, 17px)');
    line-height: 1.7;
    position: relative;
    z-index: 2;
    text-shadow: 1px -1px 2px #fff, -1px -1px 2px #fff, -1px 1px 2px #fff, 1px 1px 2px #fff;
  }
  &__img {
    position: absolute;
    bottom: 0;
    right: -1.82%;
    z-index: 1;
    width: 38.44%;
    max-width: 137px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/kanoucoco/blocks/BlockAboutFortune2.vue